import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import TcgMePage from './components/TcgMePage';
import SmartClosetPage from './components/SmartClosetPage';
import JourneyToMarsPage from './components/JourneyToMarsPage';
import RecipeBookPage from './components/RecipeBookPage';
import SpriteEditorPage from './components/SpriteEditorPage';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Projects />
              <Contact />
            </>
          } />
          <Route path="/tcgme" element={<TcgMePage />} />
          <Route path="/smartcloset" element={<SmartClosetPage />} />
          <Route path="/journeytomars" element={<JourneyToMarsPage />} />
          <Route path="/recipebook" element={<RecipeBookPage />} />
          <Route path="/spriteeditor" element={<SpriteEditorPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
